'use client';

import React, { useContext } from 'react';
import { Text } from '../Text';
import { AvatarContext } from './AvatarContext';
import { styled } from 'styled-components';
const fontMap = {
  sm: 0,
  md: 1,
  lg: 2,
  xl: 4
};
const StyledText = styled(Text).withConfig({
  componentId: "aui__sc-17rne8t-0"
})(["width:100%;text-align:center;"]);
export const Monogram = ({
  children
}) => {
  const {
    size
  } = useContext(AvatarContext);
  if (typeof children === 'string') {
    children = children.slice(0, 2).toUpperCase();
  }
  return /*#__PURE__*/React.createElement(StyledText, {
    weight: "heavy",
    size: fontMap[size]
  }, children);
};